import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Numeric = ({
  size,
  type,
  theme,
  className,
  dataTestId = "numeric-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        d="M11.676 10.111c.386-.541.579-1.316.579-2.325 0-1.002-.193-1.771-.58-2.307-.38-.542-.907-.812-1.58-.812-.329 0-.626.069-.89.207-.266.138-.493.34-.683.605-.19.265-.337.59-.441.977-.098.386-.147.83-.147 1.33 0 1.009.19 1.784.57 2.325.386.536.916.804 1.59.804.675 0 1.202-.268 1.582-.804Zm-.778-3.137c.029.242.043.513.043.812 0 .3-.014.574-.043.821-.029.248-.075.461-.138.64a.986.986 0 0 1-.26.415.587.587 0 0 1-.405.147.587.587 0 0 1-.407-.147 1.114 1.114 0 0 1-.259-.415 2.944 2.944 0 0 1-.138-.64 7.144 7.144 0 0 1-.043-.82c0-.3.014-.57.043-.813.029-.248.075-.46.138-.64.07-.178.156-.316.26-.414a.587.587 0 0 1 .405-.147c.162 0 .297.049.407.147.11.098.196.236.259.415.063.178.11.391.138.64Z"
        clipRule="evenodd"
      />
      <path d="M3.852 5.816a9.759 9.759 0 0 1-.519.233l.39.994c.2-.069.408-.15.621-.242.214-.098.407-.204.58-.32v4.313H6.21v-5.99h-.899c-.126.133-.27.26-.432.381-.155.115-.32.228-.492.337a7.954 7.954 0 0 1-.536.294Z" />
      <path
        fillRule="evenodd"
        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.667a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SVGIcon>
);
